{
  "tab": "Billing",
  "header": {
    "invoiceMilestone_one": "Invoice milestone",
    "invoiceMilestone_other": "Invoice {{count}} milestones",
    "invoiceReady_one": "Invoice 1 ready item",
    "invoiceReady_other": "Invoice {{count}} ready items",
    "invoiceUnbilled": "Invoice unbilled costs"
  },
  "status": {
    "PLANNED": "Planned",
    "READY": "Ready",
    "INVOICED": "Invoiced",
    "CANCELLED": "Cancelled"
  },
  "payment": {
    "UNPAID": "Unpaid",
    "PARTIAL": "Partly paid",
    "PAID": "Paid",
    "OVERDUE": "Overdue"
  },
  "basis": {
    "FIXED": "Fixed amount",
    "PERCENT": "Percentage"
  },
  "trigger": {
    "MANUAL": "When marked ready",
    "DATE": "On a date",
    "MILESTONE": "When a milestone is achieved"
  },
  "grouping": {
    "ROLE": "By role",
    "PERSON": "By person",
    "ENTRY": "One line per entry"
  },
  "salesOff": {
    "title": "Billing waits for Sales to be turned on",
    "body": "Sales is turned off for your company, so no invoice can be issued or voided from here. Ready items stay listed and the figures keep counting; an administrator turns Sales on in Settings › Modules."
  },
  "strip": {
    "label": "Billing figures",
    "contract": "Contract value",
    "noContract": "No contract value",
    "contractSub": "Before VAT",
    "billed": "Billed",
    "billedSub": "Before VAT, less credit notes",
    "collected": "Collected",
    "collectedSub": "{{percent}}% of {{invoiced}} invoiced incl. VAT",
    "nothingInvoiced": "Nothing invoiced yet",
    "outstanding": "Outstanding",
    "outstandingSub": "Open in Sales, incl. VAT",
    "ready": "Ready to bill",
    "readySub": "Ready plan items, before VAT",
    "readyNone": "No item is ready",
    "unbilled": "Unbilled T&M",
    "unbilledSub": "Not yet invoiced, before VAT",
    "opening": "Includes figures from before go-live (as of {{date}}): billed {{billed}}, collected {{collected}}."
  },
  "plan": {
    "title": "Billing plan",
    "covers": "The plan covers {{percent}}% of the contract value: {{total}} of {{contract}}.",
    "overContract": "more than the contract",
    "noContract": "No contract value: percentage items can't be used.",
    "split": {
      "INVOICED": "Invoiced {{amount}}",
      "READY": "Ready {{amount}}",
      "PLANNED": "Planned {{amount}}"
    },
    "percentOf": "{{percent}}% of contract",
    "total": "Plan total",
    "select": "Select {{item}}",
    "selectAll": "Select every ready item",
    "columns": {
      "select": "Select",
      "item": "Item",
      "milestone": "Milestone",
      "basis": "Basis",
      "amount": "Amount",
      "date": "Planned date",
      "status": "Status",
      "actions": "Actions"
    },
    "when": {
      "DATE": "Due for billing on {{date}}",
      "MILESTONE": "When “{{milestone}}” is achieved",
      "MANUAL": "When marked ready",
      "MANUAL_READY": "Marked ready on {{date}}",
      "cancelled": "Cancelled: {{reason}}"
    },
    "actions": {
      "label": "Actions for {{item}}",
      "add": "Add item",
      "addFirst": "Add the first item",
      "invoice": "Create invoice",
      "invoiceShort": "Invoice",
      "invoiceNamed": "Invoice {{item}}",
      "edit": "Edit",
      "ready": "Mark ready",
      "unready": "Mark not ready",
      "up": "Move up",
      "down": "Move down",
      "cancel": "Cancel item…",
      "delete": "Delete"
    },
    "bulk": {
      "label": "Selected billing items",
      "summary_one": "{{count}} ready item · {{total}}",
      "summary_other": "{{count}} ready items · {{total}}",
      "clear": "Clear selection",
      "invoice_one": "Create invoice",
      "invoice_other": "Create one invoice for {{count}} items"
    },
    "empty": {
      "canAdd": "No billing plan yet. Add the instalments the customer pays: an amount or a share of the contract, billed on a date, at a milestone or when you mark it ready.",
      "readOnly": "No billing plan yet."
    },
    "cancel": {
      "title": "Cancel “{{item}}”?",
      "body": "A cancelled item is never invoiced and leaves the plan's totals. It stays listed with your reason.",
      "reason": "Why is it cancelled?",
      "confirm": "Cancel item"
    },
    "delete": {
      "title": "Delete this item?",
      "body": "“{{item}}” was never invoiced, so it is removed from the plan.",
      "confirm": "Delete item"
    },
    "toast": {
      "ready": "Marked ready to invoice",
      "unready": "Marked not ready",
      "cancelled": "Item cancelled",
      "deleted": "Item deleted"
    }
  },
  "item": {
    "newTitle": "Add billing item",
    "editTitle": "Edit billing item",
    "description": "One instalment of the billing plan: it becomes one line of the invoice.",
    "fields": {
      "description": "Invoice line text",
      "basis": "How much",
      "amount": "Amount (ex-VAT)",
      "percent": "Percentage of the contract",
      "trigger": "Ready to invoice",
      "billDate": "Billing date",
      "expectedDate": "Expected date",
      "tax": "VAT",
      "milestone": "Milestone"
    },
    "basisBody": {
      "FIXED": "A set amount, ex-VAT.",
      "PERCENT": "A share of the contract value, worked out when it is invoiced.",
      "PERCENT_OFF": "Needs a contract value on the project."
    },
    "hints": {
      "description": "The customer reads this on the invoice.",
      "amount": "Ex-VAT: the VAT is added on the invoice.",
      "percent": "Up to 100, with two decimals.",
      "percentOf": "Bills {{amount}} of the {{contract}} contract today.",
      "billDate": "It becomes ready to invoice on this date.",
      "milestone": "It becomes ready when this milestone is achieved.",
      "milestoneOptional": "Optional: the milestone this payment belongs to."
    },
    "placeholders": {
      "description": "e.g. Mobilisation advance, 20%",
      "milestone": "Choose a milestone",
      "searchMilestone": "Search milestones…"
    },
    "noMilestones": "No milestone in the plan matches.",
    "noMilestone": "No milestone",
    "projectRate": "The project's rate",
    "projectRateNamed": "The project's rate ({{rate}})",
    "errors": {
      "description": "Enter the invoice line text.",
      "amount": "Enter an amount above zero.",
      "percent": "Enter a percentage above 0 and at most 100.",
      "percentNoContract": "Set the project's contract value first: a percentage is of the contract.",
      "plannedDate": "Choose the date it is billed.",
      "milestone": "Choose the milestone that makes it ready.",
      "field": "Check this value."
    },
    "add": "Add item",
    "save": "Save item",
    "added": "Billing item added",
    "saved": "Billing item saved"
  },
  "sheet": {
    "title": "Create invoice",
    "description": "Check the invoice {{code}} will issue before it is posted.",
    "invoiceDate": "Invoice date",
    "invoiceDateHint": "The due date follows the customer's payment terms.",
    "consequence": "This issues and posts an invoice for {{total}} (VAT {{tax}}) to {{customer}}, due {{due}}.",
    "slip": "Invoice preview",
    "billTo": "Bill to",
    "meta": "Dated {{date}} · due {{due}}",
    "reference": "Ref.",
    "previewStamp": "Preview",
    "linesCaption_one": "{{count}} item or line billed",
    "linesCaption_other": "{{count}} items or lines billed",
    "columns": {
      "description": "Line",
      "net": "Amount"
    },
    "noTax": "No VAT",
    "subtotal": "Subtotal",
    "tax": "VAT",
    "total": "Total",
    "posts": "The invoice is posted to the books at once.",
    "confirm": "Issue invoice",
    "retry": "Try again",
    "failed": "The invoice was not issued",
    "previewFailed": "The preview could not be prepared",
    "toast": "Invoice {{number}} issued",
    "toastRepeat": "Invoice {{number}} was already issued",
    "issuedTitle": "Invoice {{number}} issued",
    "issuedBody": "Invoice {{number}} for {{total}} is posted. The items it billed show as invoiced.",
    "repeatBody": "This request had already issued invoice {{number}}: nothing was issued twice.",
    "open": "Open {{number}}",
    "done": "Done"
  },
  "unbilled": {
    "title": "Unbilled time and materials",
    "hint": "Billable costs tagged to this project and not yet invoiced.",
    "markup": "Costs are re-billed at cost plus {{percent}}%, unless an amount is set by hand.",
    "showNotBillable": "Show written-off and non-billable lines",
    "notBillable": "Not billable: its cost category isn’t re-billed",
    "groupBy": "Invoice lines",
    "empty": "Nothing left to bill. Costs appear here when purchases, expenses or stock issues are tagged to this project.",
    "noCategory": "No category",
    "noNumber": "Draft",
    "time": "Time",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "costShort": "Cost",
    "total": "Billable total",
    "select": "Select {{line}}",
    "selectAll": "Select every billable line",
    "selectGroup": "Select every line of {{group}}",
    "writtenOff": "Written off",
    "writtenUp": "Written up",
    "adjusted": "Amount set by hand",
    "reason": "Reason",
    "columns": {
      "date": "Date",
      "source": "Document",
      "node": "Plan node",
      "cost": "Cost",
      "bills": "Bills"
    },
    "actions": {
      "label": "Actions for {{line}}",
      "amount": "Change amount…",
      "writeOff": "Write off…",
      "reset": "Bill at cost plus markup",
      "putBack": "Bill it again",
      "bill": "Bill this line…",
      "setAmount": "Set an amount…",
      "resetTime": "Bill at the rate"
    },
    "bulk": {
      "label": "Selected lines",
      "summary_one": "{{count}} line · {{total}}",
      "summary_other": "{{count}} lines · {{total}}",
      "invoice": "Invoice selected"
    },
    "off": {
      "title": "Write off {{line}}?",
      "body": "It won't be billed ({{amount}}). It stays listed under written-off lines and can be billed again later.",
      "confirm": "Write off"
    },
    "amount": {
      "title": "Change the amount of {{line}}",
      "body": "Cost {{cost}}; at {{markup}}% markup it bills {{amount}}. A higher amount writes it up, a lower one writes part of it off.",
      "confirm": "Save amount",
      "field": "Bill this amount (ex-VAT)",
      "hint": "Leave it empty to bill the cost plus markup.",
      "hintTime": "Leave it empty to bill the hours at the rate.",
      "hintNoRate": "There is no bill rate: the amount you enter is what it bills."
    },
    "bill": {
      "title": "Bill {{line}}?",
      "body": "Its cost category isn’t re-billed. Billed anyway, it bills {{amount}}: cost {{cost}} plus {{markup}}%.",
      "confirm": "Bill it"
    },
    "toast": {
      "off": "Line written off",
      "amount": "Amount saved",
      "bill": "Line added to what is billed",
      "cleared": "Line back to cost plus markup",
      "clearedTime": "Line back to its rate"
    },
    "timeHint": "Approved time bills at its bill rate.",
    "noRate": "No bill rate",
    "noRateHint": "Set a bill rate on the member or their role, or override the amount.",
    "noRateWaiting_one": "{{count}} time line waits for a bill rate and can't be invoiced yet.",
    "noRateWaiting_other": "{{count}} time lines wait for a bill rate and can't be invoiced yet.",
    "timeLine": {
      "hours": "{{hours}} h",
      "rate": "{{hours}} h × {{rate}}",
      "noRole": "No rate role",
      "notBillable": "Not billable: logged as non-billable time",
      "billBody": "Logged as non-billable. Billed anyway, its {{hours}} bill at the rate.",
      "amountBody": "{{hours}} at {{rate}} an hour bills {{amount}}. A higher amount writes it up, a lower one writes part of it off.",
      "amountBodyNoRate": "{{hours}} without a bill rate: enter the amount to bill."
    }
  },
  "documents": {
    "title": "Invoices and credit notes",
    "hint": "Every document of this project: issued from this tab or tagged to the project in Sales.",
    "empty": "No invoice yet. Claim, advance and retention-release invoices, invoices from the plan or for costs, and Sales documents tagged to this project are listed here.",
    "columns": {
      "number": "Document",
      "date": "Date",
      "status": "Status",
      "total": "Total",
      "balance": "Balance"
    },
    "type": {
      "INVOICE": "Invoice",
      "DEBIT_NOTE": "Debit note",
      "CREDIT_NOTE": "Credit note"
    },
    "kind": {
      "MILESTONE": "billing plan",
      "TM": "re-billed costs",
      "CLAIM": "progress claim",
      "ADVANCE": "advance",
      "RETENTION_RELEASE": "retention release",
      "ADVANCE_REDUCTION": "advance recovery"
    },
    "tagged": "tagged in Sales",
    "draft": "Draft",
    "balance": "Balance",
    "void": "Void from project",
    "voidNamed": "Void from project: {{number}}",
    "voidTitle": "Void {{number}} from the project?",
    "voidWhat": "Voids {{number}} ({{total}}, {{customer}}) in Sales, on its own date.",
    "voidBackItems": "The items it billed return to Ready, to be invoiced again.",
    "voidBackNamed_one": "{{items}} returns to Ready, to be invoiced again.",
    "voidBackNamed_other": "{{items}} return to Ready, to be invoiced again.",
    "voidBackTm": "Its re-billed costs return to unbilled.",
    "voidReasonLabel": "Why is it voided?",
    "voidConfirm": "Void invoice",
    "voided": "{{number}} voided",
    "voidReason": "Voided: {{reason}}",
    "voidBlocked": {
      "HAS_PAYMENTS": "Receipts are applied to it: take them off it in Sales first.",
      "HAS_CREDIT_NOTES": "Credit notes are issued against it: void them first.",
      "PERIOD_LOCKED": "Its date is in a locked period: it can’t be voided."
    }
  },
  "fromQuotation": {
    "quotation": "Approved quotation",
    "quotationHint": "The project takes its customer, its value and its lines.",
    "choose": "Choose a quotation",
    "search": "Search by number or customer…",
    "none": "No approved quotation matches.",
    "quotationsError": "Quotations could not be loaded.",
    "expiredMark": "Expired",
    "customer": "Customer",
    "contractValue": "Contract value",
    "exVat": "the subtotal, ex-VAT",
    "exVatQuotedInc": "the subtotal, ex-VAT (quoted VAT-inclusive)",
    "validUntil": "Valid until",
    "expiredTitle": "This quotation has expired",
    "expiredBody": "It was valid until {{date}}. Confirm the customer still accepts it before starting the project.",
    "confirmExpired": "The customer accepted it: start the project anyway",
    "typeHint": "Its functions and plan template; the billing method can be changed below.",
    "billingMethod": "Billing",
    "nameHint": "Left empty: the customer and the quotation number.",
    "endFromTemplate": "From the type's plan template; change it if the work runs longer.",
    "consequence": "Starting a project means this quotation can no longer be converted to an invoice: you bill it from the project.",
    "lines": "Quotation lines",
    "linesItems": "Lines that become billing items",
    "linesHint": {
      "FIXED_PRICE": "Each ticked line becomes a billing item of its net amount, ready to invoice when you mark it ready. Merge them or tie them to milestones later.",
      "TIME_AND_MATERIALS": "Nothing is billed from these lines: the subtotal becomes the revenue estimate of a draft budget.",
      "PROGRESS_CLAIMS": "The subtotal is the contract value; the bill of quantities comes with progress claims."
    },
    "lineAsItem": "Bill “{{line}}” as a plan item",
    "itemsCount_one": "{{count}} of {{total}} lines becomes a billing item.",
    "itemsCount_other": "{{count}} of {{total}} lines become billing items.",
    "errors": {
      "quotation": "Choose an approved quotation.",
      "billingMethod": "A quotation bills its customer: choose fixed price, time and materials or progress claims.",
      "expired": "The quotation has expired: confirm the customer still accepts it."
    },
    "save": "Start project",
    "created": "{{code}} started from {{number}}"
  },
  "projectTax": {
    "rate": "VAT on billing",
    "rateHint": "Billing plan items and re-billed costs are invoiced at this rate.",
    "companyRate": "The company's default rate",
    "pricesIncludeTax": "Quoted VAT-inclusive",
    "pricesIncludeTaxHint": "Display only: the customer was quoted prices with VAT. Invoices from the project are always ex-VAT."
  },
  "reason": {
    "required": "Give a reason."
  },
  "errors": {
    "SALES_MODULE_OFF": "Sales is turned off for your company: billing waits until an administrator turns it on.",
    "PROJECT_DOCUMENT": "This document was issued by a project: void it from the project's Billing tab.",
    "QUOTATION_STARTED_PROJECT": "This quotation started a project: bill it from the project.",
    "PROJECT_NOT_BILLABLE": "This project is not billed this way (an internal project, or another billing method).",
    "PROJECT_FEATURE_OFF": "That kind of billing is turned off for this project (Settings › Projects, or the project's functions).",
    "PROJECT_NOT_OPEN": "The project is closed or cancelled: it can't be billed.",
    "IN_USE": "It is already invoiced or in use: void its invoice from the project first.",
    "VERSION_CONFLICT": "Someone changed it meanwhile. The latest version is shown: check it and try again.",
    "CONFLICT": "Someone changed it meanwhile (it is already void or invoiced). The list shows where it stands now.",
    "notReady": "Not ready to invoice yet: its date, milestone or “Mark ready” hasn’t come.",
    "writtenOff": "A line is written off or not billable: tick only billable lines.",
    "alreadyInvoiced": "Already invoiced: someone billed it meanwhile. The plan shows its invoice.",
    "requestUsed": "This request was already used for other items. Close the sheet and start again."
  },
  "groupingHint": {
    "ROLE": "Time: one invoice line per rate role and rate. Costs: one line per cost category.",
    "PERSON": "Time: one invoice line per person and rate. Costs: one line per cost category.",
    "ENTRY": "One invoice line for each time entry (date, person and note) and for each cost."
  },
  "byClaims": {
    "title": "This contract bills through progress claims",
    "body": "Its invoices come from certified claims, the advance and retention releases, so the billing plan and costs are not invoiced here.",
    "link": "Open Contract › Claims"
  }
}
